import api from '../utils/api';

/** GET /subscription/status, as the sidebar and the payment-grace notice read it. */
export interface SubscriptionStatus {
  tier: string;
  status: string;
  canManage: boolean;
  isFreeTrial: boolean;
  trialDaysRemaining: number | null;
  trialExpired: boolean;
  /** Days left after a failed payment before the clinic is paused; null when not in that grace, 0 once it ran out. */
  paymentGraceDaysRemaining: number | null;
  /** The server's verdict: may this clinic use StableTrack right now (the API guard's rule). */
  hasAccess: boolean;
}

export const getSubscriptionStatus = async (): Promise<SubscriptionStatus> => {
  const res = await api.get('/subscription/status');
  return res.data;
};

/** Sends the owner to Stripe's billing page to update the card or pay the open invoice. */
export const openBillingPortal = async (): Promise<void> => {
  const res = await api.post('/subscription/billing-portal');
  if (!res.data?.url) throw new Error('No portal URL returned');
  window.location.href = res.data.url;
};
